
import { Experiment } from "../../../../redux/ducks/SensingSystemArchitectureDesign"


/**
 * Finds and validates the green line configuration based on the provided sensor ID,
 * location key, and experiment data.
 *
 * @param {string} sensorId - The ID of the sensor to validate.
 * @param {string} locationKey - The key of the location to validate.
 * @param {Experiment | undefined} experiment - The experiment data containing sensor information.
 * @returns {boolean} - Returns true if the sensor fields are valid, otherwise false.
 */
export const isGreenLineDataSetConfigured = (sensorId: string, locationKey: string, experiment: Experiment | undefined): boolean => {
  if (!sensorId || !locationKey || !experiment) return false

  const sensor = experiment?.data?.sensors?.[sensorId]
  if (!sensor) return false

  const sensorData = sensor.sensorLocations?.find((loc: any) => loc.locationKey === locationKey)
  if (!sensorData) return false

  return isSensorConfigurationValid(sensorData)
}

/**
 * Validates if the sensor configuration is valid based on the provided sensor data.
 *
 * @param {any} sensorData - The sensor data to validate.
 * @returns {boolean} - Returns true if the sensor data is valid, otherwise false.
 */
const isSensorConfigurationValid = (sensorData: any): boolean => {
  const hasObjects = sensorData.objects != null && Object.keys(sensorData.objects).length > 0
  const hasRedlineDatasetId = sensorData.redlineDatasetId != null && sensorData.redlineDatasetId !== ''
  return hasObjects && hasRedlineDatasetId
}
